import { JobListingItem } from '../../jobs-module/models/listing.model';
import { ServerResponse } from '../../lib/classes/serverResponse';
import { BlogPostModel } from './blog-post.model';

export class BlogListingModel extends ServerResponse {
  blog_post?: BlogPostModel;
  blog_listing_items?: JobListingItem[];
  publisher_is_draft?: boolean;
  publisher_is_published?: boolean;
  publisher_modified_at?: string;
  publisher_published_at?: number;
  created_at?: string;
  updated_at?: string;
  global_background_rgba?: string;
  global_text_style?: string;
  global_divider_status?: boolean;
  publisher_linked?: number;
}
